import { TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import Arrangement from "./Arrangement";
import MoreInformation from "./MoreInformation";

export default function MasterDetailView(props) {
  const { type, SEQ } = props;

  const renderMoreaInformation = () => {
    return <MoreInformation type={type} SEQ={SEQ} />;
  };

  const renderArrangement = () => {
    return <Arrangement type={type} SEQ={SEQ} />;
  };

  return (
    <TabPanel>
      {/* {type == "1" && <Item title="상세정보" render={renderMoreaInformation} />} */}
      {(type == "1" || type == "2") && (
        <Item title="상세정보" render={renderMoreaInformation} />
      )}

      <Item title="배치정보" render={renderArrangement} />
    </TabPanel>
  );
}
